import {Component, EventEmitter, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "../../../../environments/environment";
import TileInterface from "../../../dtos/local/Tile.interface";
import {CitiesService} from "../../../services/api/cities.service";

@Component({
  selector: 'app-system-cities-list',
  templateUrl: './system-cities-list.component.html',
  styleUrls: ['./system-cities-list.component.scss']
})
export class SystemCitiesListComponent {

  @Output() tileClicked = new EventEmitter<TileInterface>();
  @Output() loaded = new EventEmitter<TileInterface[]>();

  tiles: TileInterface[] = [];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public svc: CitiesService
  ) {
  }

  async ngOnInit() {
    const data = await this.svc.getCities();
    this.tiles = data.map(record => {
      const tile: TileInterface = {
        tileId: record.id,
        // todo: use mediaUrl pipe
        tileImage: environment.resources.imagePath(record.thumbnailUrl),
        tileName: record.name
      };

      return tile;
    });

    this.loaded.emit(this.tiles);
  }

}
